<template>
    <div class="text-center">
        <v-bottom-sheet persistent v-model="sheetShown" inset scrollable>
            <v-card style="border: 2px solid #809848;">
                <v-card-title class="grey pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                    <i style="font-size:20px; color: #809848;" class="b-fa b-fa-check-circle"></i>&nbsp;&nbsp;Crew(s) on Flight(s) - (ADD/DELETE)
                </v-card-title>
                <br />
                <span  style="margin: 0; text-align: center; color: red; font-weight: 600;" v-if="get_areThereTrtainingsFlights(get_crews_FlightData_FromCrewsToUpdate) === true">Attention: This is a Trainings-Flight. You are moving "Instructors", "Checker" or "Trainee".</span>

                <!-- >>> Left/Right Crew Panels -->
                <v-card-text style="height:900px;margin-top:24px;">
                    <v-container fluid>
                        <v-row class="ma-0">
                            <v-col class="pl-0" cols="auto" style="flex: 40%;">

                                <v-card-title class="headline">
                                    <p style="text-align:left;" class="pl-5 mb-0">
                                        Available Resources
                                    </p>
                                    <div style="display:flex;align-items:center;" class="ma-0 mb-8 pl-5">
                                        <div style="width:14px;height:14px;background:#FEDE86;border-radius: 4px;">
                                        </div>
                                        <p class="ma-0 ml-2" style="font-size:1rem;font-weight:500;text-align:left;">
                                            Cockpit: {{ resourcesOfDepartment_Filtered ? resourcesOfDepartment_Filtered.filter((x) => x.idHrDepartment === 12).length : '' }}
                                        </p>
                                        <div class="ml-8" style="width:14px;height:14px;background:#8DD1E2;border-radius: 4px;">
                                        </div>
                                        <p class="ma-0 ml-2" style="font-size:1rem;font-weight:500;text-align:left;">
                                            Cabin: {{ resourcesOfDepartment_Filtered ? resourcesOfDepartment_Filtered.filter((x) => x.idHrDepartment === 11).length : '' }}
                                        </p>
                                    </div>

                                    <!-- >>> Filter TextField -->
                                    <v-text-field style="width:calc(100% - 30px)" class="pl-5 mt-5 mb-2"
                                        v-model="filterTerm_ResourcesOfDepartment"
                                        label="Filter Resources">
                                    </v-text-field>
                                    <!-- <<< Filter TextField -->
                                </v-card-title>

                                <v-list height="580" style="overflow-y: auto;" two-line>
                                    <!-- >>> Left List: Available -->
                                    <draggable v-model="resourcesOfDepartment_Filtered" :options="{group:'people'}" style="min-height: 540px">
                                        <template v-for="item in resourcesOfDepartment_Filtered">
                                            <v-list-item :key="item.id" @dblclick="onDoubleClick_Resource(item, 'memberOnCrew')">
                                                <div class="pa-3 mb-5 custom-draggable-item" v-bind:class="{ 'custom-item-border-11': item.idHrDepartment === 11, 'custom-item-border-12': item.idHrDepartment === 12 }">
                                                    <div class="mr-auto" style="display:flex;flex-direction:column;">
                                                        <div style="display:flex;flex-direction:row;">
                                                            <p class="ma-0 font-weight-medium" style="width:40px;">
                                                                {{ item.contract3Code }}
                                                            </p>
                                                            <p class="ma-0"><span class="font-weight-medium">{{ item.genLastname + ", " + item.genFirstName }}</span><span class="text--secondary pl-3">{{ item.contractFunction }}{{ item.contractAddFunction !== '' ? " (" + item.contractAddFunction + ")" : '' }}</span></p>
                                                        </div>

                                                        <p v-if="item.idHrDepartment === 11" class="ma-0 text--secondary">Cabin</p>
                                                        <p v-if="item.idHrDepartment === 12" class="ma-0 text--secondary">Cockpit</p>
                                                    </div>
                                                    <v-icon color="#bbb">
                                                        mdi-menu
                                                    </v-icon>
                                                </div>
                                            </v-list-item>
                                        </template>
                                    </draggable>
                                    <!-- <<< Left List: Available -->
                                </v-list>
                            </v-col>

                            <v-col cols="auto" style="display:flex;align-items:center;margin-top:154px;">
                                <v-icon size="26" color="primary">
                                    mdi-swap-horizontal
                                </v-icon>
                            </v-col>

                            <v-col class="pl-0 pr-3" cols="auto" style="flex: 40%;">
                                <v-card-title class="headline">
                                    <p style="text-align:left;" class="pl-5 mb-0">
                                        Current Crew
                                    </p>
                                    <div style="display:flex;align-items:center;" class="ma-0 mb-2 pl-5">
                                        <div style="width:14px;height:14px;background:#FEDE86;border-radius: 4px;">
                                        </div>
                                        <p class="ma-0 ml-2" style="font-size:1rem;font-weight:500;text-align:left;">
                                            Cockpit: {{ memberOnCrew_Filtered ? memberOnCrew_Filtered.filter((x) => x.idHrDepartment === 12).length : '' }}
                                        </p>
                                        <div class="ml-8" style="width:14px;height:14px;background:#8DD1E2;border-radius: 4px;">
                                        </div>
                                        <p class="ma-0 ml-2" style="font-size:1rem;font-weight:500;text-align:left;">
                                            Cabin: {{ memberOnCrew_Filtered ? memberOnCrew_Filtered.filter((x) => x.idHrDepartment === 11).length : '' }}
                                        </p>
                                    </div>

                                    <!-- >>> Sort SelectField -->
                                    <v-select
                                        style="width:calc(100% - 30px)"
                                        v-model="sortBy"
                                        :items="memberOnCrew_SortItems"
                                        item-text="text"
                                        item-valur="value"
                                        class="pl-5 mt-8 mb-2"
                                        label="Sort by">
                                    </v-select>
                                    <!-- <<< Sort SelectField -->

                                </v-card-title>

                                <v-list height="580" style="overflow-y: auto;" two-line>
                                    <!-- >>> Right List: New Crew -->
                                    <draggable v-model="memberOnCrew_Filtered" :options="{group:'people'}" style="min-height: 540px" @change="onChange_MemberOnCrew">
                                        <template v-for="item in memberOnCrew_Filtered">
                                            <v-list-item :key="item.id" @dblclick="onDoubleClick_Resource(item, 'resourcesOfDepartment')">
                                                <div class="pa-3 mb-5 custom-draggable-item" v-bind:class="{ 'custom-item-border-11': item.idHrDepartment === 11, 'custom-item-border-12': item.idHrDepartment === 12, 'custom-item-added': memberOnCrew_addedIds.includes(item.id) === true }">
                                                    <div style="display:flex;flex-direction:column;">
                                                        <div style="display:flex;flex-direction:row;">
                                                            <p class="ma-0 font-weight-medium" style="width:40px;">
                                                                {{ item.contract3Code }}
                                                            </p>
                                                            <p class="ma-0"><span class="font-weight-medium">{{ item.genLastname + ", " + item.genFirstName }}</span><span class="text--secondary pl-3">{{ item.contractFunction }}{{ item.contractAddFunction !== '' ? " (" + item.contractAddFunction + ")" : '' }} - {{ item.id }}</span></p>
                                                        </div>

                                                        <p v-if="item.idHrDepartment === 11" class="ma-0 text--secondary">Cabin</p>
                                                        <p v-if="item.idHrDepartment === 12" class="ma-0 text--secondary">Cockpit</p>
                                                    </div>
                                                    <p v-if="memberOnCrew_addedIds.includes(item.id) === true" style="color:#DBAEC7;font-size:1.3rem;" class="ma-0 ml-auto mr-4 font-weight-regular">ADDED</p>
                                                    <v-icon color="#bbb">
                                                        mdi-menu
                                                    </v-icon>
                                                </div>
                                            </v-list-item>
                                        </template>
                                    </draggable>
                                    <!-- <<< Right List: New Crew -->
                                </v-list>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <!-- <<< Left/Right Crew Panels -->

                <!-- >>> Action Buttons - Bottom -->
                <v-card-actions>
                    <p class="mb-0 ml-5 font-weight-medium">Crew(s) is/are from/for Flight(s): {{ get_crews_FlightData_FromCrewsToUpdate }}
                    </p>
                    <v-spacer></v-spacer>
                    <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet"> Close</v-btn>
                    <v-btn style="width:120px" depressed elevation="1" color="primary" @click="onClick_SaveUpdatedCrew"> Save</v-btn>
                </v-card-actions>
                <!-- <<< Action Buttons - Bottom -->
            </v-card>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../main';
    import draggable from 'vuedraggable';


    export default {
        name: 'CrewsBottomSheet',

        /* >>> *************************************************************** / /* Components */
        components: {

            draggable

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Props */
        props: {

            value : [Boolean], // 'showSheet'
            get_areThereTrtainingsFlights: Function,

		},  // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
		data: function() {

			return {
                memberOnCrew_SortItems: [
                    {
                        text: 'First Name',
                        value: 'firstname'
                    },
                    {
                        text: 'Last Name',
                        value: 'lastname'
                    },
                    {
                        text: 'Department',
                        value: 'department'
                    }
                ],
                memberOnCrew_addedIds: [],
                isThisATrainingsFlight: false
            };

		}, // eo funtion data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_MemberOnCrew',
                'get_crews_FlightData_FromCrewsToUpdate', // mimic original 'People' function
                'get_MemberOnCrew_Edited',
                'get_MemberOnCrew_Edited_Before', // get before Zustand
                'get_crews_ResourcesOfDepartment_Filtered',
                'get_crews_FilterTerm_ResourcesOfDepartment',
                'get_crews_SortBy_MemberOfCrew',
                'get_selectedMultiEventsFlights',
			]),



            /*******************************************************************
			* sheetShown{}
			*
			* Desc:
			* Note:
			*
			*/
            sheetShown: {

				get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/sheetShown/get');
                    // sort members on crew
                    if(me.value === true && me.sortBy === 'none') {
                        me.sortBy = 'department';
                    }


                    return me.value;

                }, // eo function sheetShown get()

				set(value) {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/sheetShown/set');
                    me.$emit('input', value);

                }, // eo function sheetShown set()

            }, // eo sheetShown{}


            /*******************************************************************
			* sortBy{}
			*
			* Desc: Resources of Department for the Bottom Sheet.
			* Note:
			*
			*/
            sortBy: {

                get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/sortBy/get');
                    return this.get_crews_SortBy_MemberOfCrew;

                }, // eo function sortBy get()

                set(value) {

                    let me = this;

                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/sortBy/set');
                    this.actn_update_crews_SortBy_MemberOfCrew(value); // ToDo: on again?

                } // eo function sortBy set()

            }, // eo sortBy{}


            /*******************************************************************
			* resourcesOfDepartment_Filtered{}
			*
			* Desc: Resources of Department for the Bottom Sheet.
			* Note:
			*
			*/
            resourcesOfDepartment_Filtered: {

                get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/resourcesOfDepartment_Filtered/get');
                    return me.get_crews_ResourcesOfDepartment_Filtered;

                }, // eo function resourcesOfDepartment_Filtered get()

                set(value) {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/resourcesOfDepartment_Filtered/set');
                    me.actn_update_crews_ResourcesOfDepartment(value);

                }, // eo function resourcesOfDepartment_Filtered set()

            }, // eo resourcesOfDepartment_Filtered{}


            /*******************************************************************
			* memberOnCrew_Filtered{}
			*
			* Desc: Member on Crew for the Bottom Sheet.
			* Note:
			*
			*/
            memberOnCrew_Filtered: {

                get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/memberOnCrew_Filtered/get');
                    return me.get_MemberOnCrew_Edited.crew;

                }, // eo function memberOnCrew_Filtered get()

                set(value) {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/memberOnCrew_Filtered/set');
                    me.actn_update_crews_MemberOnCrew(value); // TODO: ON AGAIN?=

                    //reset sort
                    me.sortBy = 'none';

                }, // eo function memberOnCrew_Filtered set()

            }, // eo memberOnCrew_Filtered{}


            /*******************************************************************
			* filterTerm_ResourcesOfDepartment{}
			*
			* Desc: Filter Term for filtering the resources of department.
			* Note:
			*
			*/
            filterTerm_ResourcesOfDepartment: {

                get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/filterTerm_ResourcesOfDepartment/get');
                    return me.get_crews_FilterTerm_ResourcesOfDepartment;

                }, // eo function filterTerm_ResourcesOfDepartment get()

                set(value) {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> computed/filterTerm_ResourcesOfDepartment/set');
                    me.actn_update_crews_FilterTerm_ResourcesOfDepartment(value);

                }, // eo function filterTerm_ResourcesOfDepartment set()

            }, // eo filterTerm_ResourcesOfDepartment{}

        }, // eo computed{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> created');
            eventBus.$on('crewswasupdatedcreated', this.onClick_CloseSheet);

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> destroyed');
            eventBus.$off('crewswasupdatedcreated', this.onClick_CloseSheet);

		}, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
		methods: {

            ...mapActions([
                'actn_set_Warning',
                'actn_call_updateCreateCrew',
                'actn_update_crews_ResourcesOfDepartment',
                'actn_update_crews_MemberOnCrew',
                'actn_update_crews_FilterTerm_ResourcesOfDepartment',
                'actn_update_crews_SortBy_MemberOfCrew',
                'actn_reset_crews_ResourcesOfDepartment_Filtered',
                'actn_sort_ResourcesOfDepartment',
                'actn_call_updateCrewmemberFromFlights'
            ]),


            /*******************************************************************
            * Forms:
            *******************************************************************/
            /*******************************************************************
            * onClick_SaveUpdatedCrew()
            *
            * Desc: Save new/updated Crew.
            *
            */
            onClick_SaveUpdatedCrew: function() {

                let me = this,
                    params = {},
                    idFlightsArray = [],
                    arrayOfMembersBeforeUpdate = [],
                    arrayOfMembersAfterUpdate = [...this.create_CrewIdsArray()],
                    arrayOfMembersDeletedFromBefore = [],
                    arrayOfMembersAddedToBefore = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> onClick_SaveUpdatedCrew');
                // >>> The List before --------------------
                this.get_MemberOnCrew_Edited_Before.crew.forEach(member => {
                    arrayOfMembersBeforeUpdate.push(member.id)
                });

                // >>> The List of deleted from before ----
                arrayOfMembersDeletedFromBefore = arrayOfMembersBeforeUpdate.filter(x => !arrayOfMembersAfterUpdate.includes(x));

                // >>> The List of added to before --------
                arrayOfMembersAddedToBefore = arrayOfMembersAfterUpdate.filter(x => !arrayOfMembersBeforeUpdate.includes(x));

                // >>> ------------------------------------
                if (arrayOfMembersAddedToBefore.length === 0 && arrayOfMembersDeletedFromBefore.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Pardon, this is the same Crew than before.'
                    });
                } else {
                    idFlightsArray = [...this.get_crews_FlightData_FromCrewsToUpdate]
                    params = {
                        params: {
                            "idFlights": idFlightsArray,
                            "resourcesIdstoAdd": arrayOfMembersAddedToBefore,
                            "resourcesIdstoRemove": arrayOfMembersDeletedFromBefore
                        },
                        draggedRecords: null,
                        newResource: null
                    };

                    // >>> 'Warning/Call' -----------------
                    me.actn_set_Warning({
                        title: 'Add/Delete Crews(s) on Flight(s)',
                        text:   `<div>
                                    <p style="margin: 0; text-align: center">Do you really want to adde/delete these crew(s) on flight(s) ?</p>
                                    <div style="display:flex;padding-top:28px;font-weight:500">
                                    </div>
                                `,
                        payload: null,
                        acceptFunction: () => me.actn_call_updateCrewmemberFromFlights(params),
                        declineFunction: () => null,
                    });
                }

            }, // eo function onClick_SaveUpdatedCrew()


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onDoubleClick_Resource()
            *
            * Desc: Simulate the drag'n'drop event with a double click.
            * Note:
            *
            */
            onDoubleClick_Resource: function (item, to) {

                let me = this,
                    copy_MemberOnCrew = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> onDoubleClick_Resource');
                if (to === 'memberOnCrew') {
                    //add resource id to addedIds Array
                    this.memberOnCrew_addedIds.push(item.id);
                    //filter out from resources
                    this.resourcesOfDepartment_Filtered = this.resourcesOfDepartment_Filtered.filter(x => x.id !== item.id);
                    //add to members of Crew
                    copy_MemberOnCrew = [ ...this.memberOnCrew_Filtered ];
                    copy_MemberOnCrew.unshift(item);
                    this.memberOnCrew_Filtered = copy_MemberOnCrew;
                    // this.memberOnCrew_Filtered.push(item); // this does not work!! think there are some reference errors..
                }

                if (to === 'resourcesOfDepartment') {
                    //remove resource id to addedIds Array
                    this.memberOnCrew_addedIds.filter(x => x !== item.id);
                    //filter out from members
                    this.memberOnCrew_Filtered = this.memberOnCrew_Filtered.filter(x => x.id !== item.id);
                    //add to resources of Department
                    this.resourcesOfDepartment_Filtered.unshift(item);
                }

            }, // eo function onDoubleClick_Resource()


            /*******************************************************************
            * onChange_MemberOnCrew()
            *
            * Desc: Save the added member Ids.
            * Note: Used only for optical features.
            *
            */
            onChange_MemberOnCrew: function(e) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> onChange_MemberOnCrew');
                if ('added' in e) {
                    this.memberOnCrew_addedIds.push((e.added.element.id));
                }

            }, // eo function onChange_MemberOnCrew()


            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
			onClick_CloseSheet: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> onClick_CloseSheet');
                this.actn_reset_crews_ResourcesOfDepartment_Filtered();
                this.memberOnCrew_addedIds = [];
                this.filterTerm_ResourcesOfDepartment = '';
                this.sortBy = 'none';
				this.sheetShown = false;

                this.resourcesOfDepartment_Filtered = []; // #583

            }, // eo function onClick_CloseSheet()




            /*******************************************************************
            * Utilities/Helper:
            *******************************************************************/
            /******************************************************************* 'Format - Dates'
            * create_CrewIdsArray()
            *
            * Desc: Create CrewIds Array for Payload.
            * Note:
            *
            */
            create_CrewIdsArray: function() {

                let me = this,
                    crewIds = [];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewupdate/BottomSheetMeberOnCrew.vue >>> create_CrewIdsArray');
                crewIds = this.get_MemberOnCrew_Edited.crew.map((member) => member.id);


                return crewIds;

            }, // eo function create_CrewIdsArray()

        } // eo methods{}

    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        max-height:700px;
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }

    .custom-draggable-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background:#FFF;
        width:100%;
        box-shadow:rgb(210 210 210) 0px 0px 8px 0px;
        border-radius:4px;
    }

    .custom-item-border-11 {
        border-left: 8px solid #8DD1E2;
    }

    .custom-item-border-12 {
        border-left: 8px solid #FEDE86;
    }

    .custom-item-added {
        background: #FFF3FA;
    }
</style>

<style>
    .v-input__icon--append .v-icon {
        color: #ab3b7a;
    }

    .theme--light.v-label {
        color: rgba(0, 0, 0, 1);
    }
</style>
